<template lang="pug">
  v-list(:class="listClasses" v-bind="$attrs" v-on="$listeners")
    slot
</template>

<script>
import { getParentClasses, hasPaddingClasses } from '@/utils'

export default {
  name: 'YzList',
  inheritAttrs: false,
  props: {
    fontClass: {
      type: String,
      default: 'yz-regular-body-sm'
    }
  },
  computed: {
    listClasses() {
      const parentClass = getParentClasses(this.$vnode)
      
      const classes = [this.fontClass]
      
      if (hasPaddingClasses(parentClass)) {
        classes.push(parentClass)
      } else {
        classes.push(`py-0 ${parentClass}`.trim())
      }
      
      return classes
    }
  }
}
</script>

<style lang="scss" scoped>
// Add any custom YzList styling here if needed
</style>